// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {

    RivalIQ = {
        enums: {}
    };

    module.exports = RivalIQ.enums;
} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('enums', function () {});
}

(function (enums) {
    'use strict';

    enums.user = {
        status: {
            active: {
                id: 1,
                name: 'active'
            },
            disabled: {
                id: 2,
                name: 'disabled'
            },
            registration: {
                id: 3,
                name: 'registration'
            },
            invited: {
                id: 4,
                name: 'invited'
            }
        }
    };
})(RivalIQ.enums);
